import "./TabelaPontuacaoGeral.css"

import GeneralPaginator from "../GeneralPaginator/GeneralPaginator"

import leaoImagem from '../../assets/img/leao.svg'
import tigreImagem from '../../assets/img/tigre.svg'
import pinguimImagem from '../../assets/img/pinguim.svg'
import girafaImagem from '../../assets/img/girafa.svg'
import hipopotamoImagem from '../../assets/img/hipopotamo.svg'
import zebraImagem from '../../assets/img/zebra.svg'
import jaguarImagem from '../../assets/img/jaguar.svg'
import vacaLeiteiraImagem from '../../assets/img/vaca.svg'
import suricatoImagem from '../../assets/img/suricato.svg'

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { get } from "../../services/api"
import { json2csv } from 'json-2-csv';
import { Fragment, useState } from "react"

export default function TabelaPontuacaoGeral({ carregando, pontuacao, matricula, setMatricula, nome, setNome, setPontuacaoByNomeAndMatricula, setPontuacaoByPage, page, setPage, filtros }) {

    const [ matriculaInput, setMatriculaInput ] = useState('');
    const [ nomeInput, setNomeInput ] = useState('');
    
    const VARIANTE_FUNCIONARIO = 1;
    const VARIANTE_FILIAL = 2;

    const imagemMapeada = {
        1: leaoImagem,
        2: tigreImagem,
        3: pinguimImagem,
        4: girafaImagem,
        5: zebraImagem,
        6: hipopotamoImagem,
        7: jaguarImagem,
        8: vacaLeiteiraImagem,
        10: suricatoImagem,
        11: zebraImagem
    }
    
    const formatarValor = (val) => {
        return parseFloat(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    async function getAllPontuacao() {
        const authToken = localStorage.getItem('adminToken');
        const res = await get(
            `/admin/pontuacaogeral?mes=${filtros.periodo.split('/')[0]}&ano=${filtros.periodo.split('/')[1]}&regiao=${filtros.regiao}&idfilial=${filtros.idfilial}&tipo_pontuacao=${filtros.tipo_pontuacao}&variante_pontuacao=${filtros.variante_pontuacao}&matricula=${filtros.matricula}&nome=${filtros.nome}&page=${1}&max=${100000}`,
            null,
            authToken
        );

        return res.data
    }

    const downloadCSV = async () => {
        const data = await getAllPontuacao()
        const keyMap = {
            1: 'Leão',
            2: 'Tigre',
            3: 'Pinguim',
            4: 'Girafa',
            5: 'Zebrinha',
            6: 'Hipopótamo',
            7: 'Jaguar',
            8: 'Vaca Leiteira',
            9: 'Campanhas',
            10: 'Suricato',
            11: 'Zebra Velha'
        }

        data.forEach(dataElement => {
            delete dataElement.full_count
            delete dataElement.id_tipo_pontuacao
            delete dataElement.ano
            delete dataElement.mes
            delete dataElement.id_vendedor
        })

        const formattedData = []
        data.forEach(dataElement => {
            const newDataElement = {}
            
            if(filtros.variante_pontuacao == VARIANTE_FUNCIONARIO) {
                newDataElement['Matrícula'] = dataElement.matricula
                newDataElement['Nome'] = dataElement.nome
                newDataElement['Filial'] = dataElement.idfilial
                newDataElement['Tipo'] = dataElement.tipo_pontuacao
            } else {
                newDataElement['Cod Filial'] = dataElement.idfilial
                newDataElement['Filial'] = dataElement.filial
            }

            dataElement.animais.forEach(animal => {
                const key = keyMap[animal.id_animal];
                const valores = dataElement.pontuacoes.find(p => p.id_animal == animal.id_animal);

                if(pontuacao.id_animal != 9) 
                    newDataElement[`${key} (Valor)`] = valores?.valor || 0;
                newDataElement[`${key} (Pontos)`] = valores?.pontuacao || 0;

                if(pontuacao.id_animal != 9) 
                    newDataElement[`${key} Projetado (Valor)`] = valores?.valor_projetado || 0;
                newDataElement[`${key} Projetado (Pontos)`] = valores?.pontuacao_projetado || 0;
            })

            newDataElement['Pontuação Total'] = dataElement.pontuacoes.reduce((pontuacaoTotal, pontuacaoAnimal) => 
                pontuacaoTotal + pontuacaoAnimal.pontuacao, 0
            )
            newDataElement['Pontuação Total Projetado'] = dataElement.pontuacoes.reduce((pontuacaoTotal, pontuacaoAnimal) => 
                pontuacaoTotal + pontuacaoAnimal.pontuacao_projetado, 0
            )

            formattedData.push(newDataElement)
        })

        try {
            const csv = json2csv(formattedData, { delimiter: { field: ';' } })
            const BOM = new Uint8Array([0xEF,0xBB,0xBF]);
            const blob = new Blob([BOM, csv], { type: 'text/csv;' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            const nomeCSV = filtros.variante_pontuacao == VARIANTE_FUNCIONARIO 
                ? 'Excelencia_Relatorio_PontuacaoGeral.csv'
                : 'Excelencia_Relatorio_PontuacaoFilial.csv'

            link.setAttribute('download', nomeCSV);
            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error converting JSON to CSV:', error);
        }
    }

    const retornarCampoAnimal = (animal, data) => {
        const dados = data.pontuacoes.find(p => p.id_animal == animal.id_animal);

        if(typeof dados === 'undefined') {
            return '----';
        }
        
        let campo;
        if(dados.tipo_percentual) {
            campo = dados.valor;
        } else {
            campo = formatarValor(dados.valor);
        }

        campo += dados.tipo_percentual ? '%' : '';

        return campo;
    }

    const retornarCampoCampanha = (data) => {
        const campanha = data.animais.find(a => a.id_animal == 9);
        if(typeof campanha === 'undefined') {
            return <></>
        }

        const dados = data.pontuacoes.find(p => p.id_animal == 9);

        return  <td colSpan={2} className='metas-data last-meta'>
                    {typeof dados !== 'undefined' ? `${dados.pontuacao}pts` : '----'}
                </td>
    }

    return (
        <div className='pontuacao-geral-second'>
            <div className='header'>
                <div>
                    <span>2</span>
                    <h1>Consultar Pontuação</h1>
                </div>
                <button onClick={downloadCSV} className="get-csv" disabled={carregando || pontuacao?.data?.length == 0}>
                    <FileDownloadIcon style={{width: '25px', height: '25px', marginRight: '10px'}} />
                    Exportar CSV
                </button>
            </div>
            <div className='body'>
                {filtros.variante_pontuacao == VARIANTE_FUNCIONARIO &&   
                    <div className="filtros-runtime">
                        <div className="matricula-wrapper">
                            <label htmlFor="matricula">Matrícula</label>
                            <input type="text" name="matricula" id="matricula" maxLength={8} value={matriculaInput} 
                            onChange={(e) => {
                                const formattedValue = e.target.value.replace(/\D/g, '')
                                setMatriculaInput(formattedValue)
                            }} />
                        </div>
                        <div className="nome-wrapper">
                            <label htmlFor="nome">Nome</label>
                            <input type="text" name="nome" id="nome" value={nomeInput} onChange={(e) => {
                                setNomeInput(e.target.value)
                            }} />
                        </div>
                        <button className="filtrar-btn" onClick={() => {
                            setMatricula(matriculaInput);
                            setNome(nomeInput);

                            setPontuacaoByNomeAndMatricula(matriculaInput, nomeInput);
                        }}>
                            Filtrar
                        </button>
                    </div>
                }
                <div className="table-wrapper">
                    {pontuacao?.data?.length > 0 
                        ?   <table className="adm-table pontuacao-table">
                                <thead>
                                    <tr>
                                        {filtros.variante_pontuacao == VARIANTE_FUNCIONARIO 
                                            ?   <>
                                                    <th>Matrícula</th>
                                                    <th>Nome</th>
                                                    <th>Filial</th>
                                                    <th>Tipo</th>
                                                </>
                                            :   <>
                                                    <th className="name-column">Cód. Filial</th>
                                                    <th>Nome</th>
                                                </>
                                        }

                                        {pontuacao.data[0].animais.filter(a => a.id_animal != 9).map((animal, index) => (
                                            <th key={animal.id_animal} className={`metas-header ${index == pontuacao.data[0].animais.length - 1 ? '' : ''}`} colSpan={2}>
                                                <div>
                                                    <img src={imagemMapeada[animal.id_animal]} alt={`Imagem ${animal.animal}`} />
                                                    {animal.animal}
                                                </div>
                                            </th>
                                        ))}
                                        {pontuacao.data[0].animais.find(a => a.id_animal == 9) &&
                                            <th className='metas-header last-meta-header' colSpan={2}>
                                                <div>
                                                    {pontuacao.data[0].animais.find(a => a.id_animal == 9).animal}
                                                </div>
                                            </th>
                                        }

                                        <th className="after-metas-data">Pontuação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {carregando &&  
                                        <tr className="loading-table">
                                            <td><span></span></td>
                                        </tr>
                                    }
                                    {pontuacao.data.map(data => (
                                        <tr key={data.matricula} className="adm-table-row">
                                            {filtros.variante_pontuacao == VARIANTE_FUNCIONARIO 
                                            ?   <>
                                                    <td>{data.matricula}</td>
                                                    <td className="name-column">{data.nome}</td>
                                                    <td>{data.idfilial}</td>
                                                    <td className="before-metas-data">{data.tipo_pontuacao}</td>
                                                </>
                                            :   <>
                                                    <td className="center">{data.idfilial}</td>
                                                    <td className="name-column before-metas-data">{data.filial}</td>
                                                </>
                                            }
                                            
                                            {data.animais.filter(a => a.id_animal != 9).map((animal, index) => (
                                                <Fragment key={animal.id_animal}>
                                                    <td className={`metas-data ${index == 0 ? 'first-meta' : ''}`}>
                                                        {retornarCampoAnimal(animal, data)} 
                                                    </td>
                                                    <td className={`metas-data ${index == data.pontuacoes.length - 1 ? 'last-meta' : ''}`}>
                                                        {data.pontuacoes.find(p => p.id_animal == animal.id_animal)
                                                            ?   `${data.pontuacoes.find(p => p.id_animal == animal.id_animal).pontuacao}pts`
                                                            :    '----'
                                                        }
                                                    </td>
                                                </Fragment>
                                            ))}

                                            {retornarCampoCampanha(data)}

                                            <td key={data.matricula} className="after-metas-data">{data.pontuacoes.reduce(
                                                (pontuacaoTotal, pontuacaoAnimal) => pontuacaoTotal + pontuacaoAnimal.pontuacao, 0)
                                            }pts</td>
                                        </tr>
                                    ))}
                                    
                                </tbody>
                            </table>
                        :   <span className="no-data-found">
                                <WarningAmberIcon style={{width: '50px', height: '50px', marginBottom: '5px'}} />
                                <span>Não foram encontrados dados com os filtros selecionados</span>
                            </span>
                    }
                    
                </div>
                {pontuacao?.data?.length > 0 && 
                    <div className="paginator-wrapper">
                        <GeneralPaginator page={page} setPage={setPage} numberOfPages={pontuacao.numberOfPages} setTableByPage={setPontuacaoByPage} />
                    </div>
                }
            </div>
        </div>
    );
}
